import { SharedI18nModule } from '@bizzdesign/shared/i18n';
import { SelectComponent } from '@bizzdesign/ui-select';
import {
  ItemGridComponent,
  ItemGridLoadingComponent,
} from '@bizzdesign/ui-item-grid';
import {
  ItemViewComponent,
  ItemViewLoadingComponent,
} from '@bizzdesign/ui-item-view';
import { PaginationComponent } from '@bizzdesign/ui-pagination';
import { SearchTabEmptyStateComponent } from './search-tab-empty-state/search-tab-empty-state.component';

/**
 * Standalone `imports` shared by the Views and Workspaces search-result tabs,
 * which render the same grid/list/select/pagination/empty-state building blocks.
 */
export const searchResultsTabImports = [
  SharedI18nModule,
  SelectComponent,
  ItemGridComponent,
  ItemGridLoadingComponent,
  ItemViewComponent,
  ItemViewLoadingComponent,
  PaginationComponent,
  SearchTabEmptyStateComponent,
];
